import React from "react";
import FilterRadioButtons from "../../forms/filter-radio-buttons";
import {
  customerStatusoptions,
  partyTypeFilterOptions,
} from "../../helper-components/data";

const CustomerFilter = ({ setFilterData, filterData }) => {
  const handlecustomerStatusChange = (e) => {
    setFilterData({
      ...filterData,
      customer_status: e.target.value,
    });
  };

  const handlePartyTypeChange = (value) => {
    const selected = filterData?.party_types || [];
    const updated = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];
    setFilterData({
      ...filterData,
      party_types: updated,
    });
  };

  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "17rem",
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0 12px 32px -8px var(--popover-shadow-color), 0 2px 6px -2px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-3 px-2  bg-[var(--popover-bg-color)]  rounded-xl z-10 flex flex-col"
    >
      <span className="px-3 pt-1.5 pb-2.5 text-sm fw_600 text-[var(--popover-heading-fg-color)]">
        Filter by
      </span>
      <hr className="border-0 border-t border-[var(--popover-border-color)] -mx-2" />
      <div>
        <FilterRadioButtons
          name="customer_status"
          label={"Customer Type"}
          options={customerStatusoptions}
          handleChange={handlecustomerStatusChange}
          value={filterData?.customer_status}
        />
      </div>
      <div className="px-3 flex flex-col mt-3 ml-1">
        <label className="font-[var(--popover-heading-font-weight)] text-[length:--popover-font-size] text-[var(--popover-heading-fg-color)]">
          BUSINESS ASSOCIATIONS
        </label>
        <div className="flex gap-2 flex-col mt-3 ml-1">
          {partyTypeFilterOptions?.map((option) => (
            <div key={option?.value} className="flex items-center">
              <input
                type="checkbox"
                id={option.value}
                name={option.value}
                checked={filterData?.party_types?.includes(option.value) || false}
                onChange={() => handlePartyTypeChange(option.value)}
              />
              <label
                htmlFor={option.value}
                className="ml-2 font-[var(--popover-font-weight)] cursor-pointer text-[length:--popover-font-size] text-[var(--popover-fg-color)] whitespace-nowrap"
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerFilter;
